<app-ui-main-menu>
  <mat-card class="indications-page">
    <mat-card-header>
      <mat-card-title>Pagamentos</mat-card-title>
    </mat-card-header>

    <mat-card-content class="page-content">
      <form [formGroup]="filters" class="filters" (ngSubmit)="applySearch()" novalidate>
        <div class="box-select history-box">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Semana consolidada</mat-label>
            <input
              matInput
              type="search"
              autocomplete="off"
              [formControl]="historyInputControl"
              placeholder="Buscar período disponível"
              (focus)="openHistoryList()"
              (blur)="closeHistoryList()"
              (keyup.enter)="applySearch()"
            />
          </mat-form-field>

          <mat-action-list [ngClass]="{ aberto: showHistoryList, fechado: !showHistoryList }">
            <button
              *ngFor="let history of filteredHistories"
              mat-list-item
              type="button"
              (mousedown)="selectHistory(history)"
            >
              <span class="history-option">
                <span class="history-period">
                  Semana de {{ formatDate(history.startDate) }} a
                  {{ formatDate(history.endDate) }}
                </span>
              </span>
            </button>
            <mat-list-item *ngIf="filteredHistories.length === 0" role="listitem">
              Nenhum período encontrado
            </mat-list-item>
          </mat-action-list>
        </div>

        <div class="searchBtn">
          <button mat-flat-button color="primary" type="submit">Pesquisar</button>
        </div>

        <div class="searchBtn">
          <button
            mat-flat-button
            type="button"
            class="advanced-btn"
            [color]="activeFiltersApplied ? 'warn' : 'primary'"
            [ngClass]="{ 'clear-filters': activeFiltersApplied }"
            [disabled]="!isPaidTab && !isAptosTab"
            [matTooltip]="!isPaidTab && !isAptosTab ? 'Filtros disponíveis apenas em Pagamentos Aptos e Realizados' : ''"
            [matTooltipDisabled]="isPaidTab || isAptosTab"
            (click)="onFiltersClick()"
          >
            {{ activeFiltersApplied ? 'Limpar filtros' : 'Filtros avançados' }}
          </button>
        </div>

        <div class="searchBtn" *ngIf="activeTab === 'aptos'">
          <button
            mat-flat-button
            type="button"
            class="transfer-btn"
            [disabled]="isBlocking || !dataSource.data.length"
            (click)="onTransferAptasClick()"
          >
            Efetuar Pagamentos
          </button>
        </div>
      </form>

      <p class="filters-summary" *ngIf="isPaidTab && paidFiltersApplied && paidFiltersSummary">
        Filtros aplicados: {{ paidFiltersSummary }}
      </p>

      <p class="filters-summary" *ngIf="isAptosTab && availableFiltersApplied && availableFiltersSummary">
        Filtros aplicados: {{ availableFiltersSummary }}
      </p>

      <mat-tab-group (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Pagamentos Aptos">
          <ng-template matTabContent>
            <ng-container *ngIf="activeTab === 'aptos'">
              <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
            </ng-container>
          </ng-template>
        </mat-tab>

        <mat-tab label="Pagamentos Pendentes">
          <ng-template matTabContent>
            <ng-container *ngIf="activeTab === 'inaptos'">
              <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
            </ng-container>
          </ng-template>
        </mat-tab>

        <mat-tab label="Pagamentos Realizados">
          <ng-template matTabContent>
            <ng-container *ngIf="activeTab === 'pagos'">
              <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
            </ng-container>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <div class="inline-loading" *ngIf="isTopSpinnerBusy">
        <mat-progress-spinner
          diameter="32"
          strokeWidth="4"
          mode="indeterminate"
        ></mat-progress-spinner>
      </div>

      <ng-template #tableTemplate>
        <div
          class="table-shell"
          [class.loading]="isTableBusy"
          [class.empty-state]="dataSource.data.length === 0"
        >
          <div class="table-blocker" *ngIf="isTableBusy"></div>
          <div *ngIf="!isBlocking && dataSource.data.length === 0" class="empty">
            <h3>Nenhum conteúdo disponível</h3>
          </div>

          <div
            *ngIf="dataSource.data.length > 0"
            class="table-scroll"
            tabindex="0"
          >
            <table
              mat-table
              [dataSource]="dataSource"
              class="wide-table"
              [class.with-reason]="shouldShowReasonColumn"
              [class.without-reason]="!shouldShowReasonColumn"
              [class.aid-table]="isPaidTab"
              [trackBy]="trackByRow"
            >
              <ng-container *ngIf="showSelectionColumn" matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="select-col">
                  <mat-checkbox
                    color="primary"
                    [checked]="isAllSelected()"
                    [indeterminate]="isIndeterminate()"
                    [disabled]="selectionWorking"
                    disableRipple
                    (change)="toggleAllRows($event.checked)"
                    matTooltip="Selecionar todas as indicações listadas"
                  >
                    Todas
                  </mat-checkbox>
                  <span
                    class="checkbox-spinner-wrapper"
                    *ngIf="selectionWorking && selectionAllLoading"
                  >
                    <mat-progress-spinner
                      diameter="14"
                      strokeWidth="3"
                      mode="indeterminate"
                      class="checkbox-spinner"
                    ></mat-progress-spinner>
                  </span>
                </th>
                <td mat-cell *matCellDef="let row" class="select-col">
                  <mat-checkbox
                    color="primary"
                    [checked]="selection.isSelected(row)"
                    [disabled]="selectionWorking"
                    disableRipple
                    (change)="toggleRowSelection(row, $event.checked)"
                  >
                  </mat-checkbox>
                  <span
                    class="checkbox-spinner-wrapper"
                    *ngIf="
                      selectionWorking &&
                      selectionRowLoadingId === getRowKey(row) &&
                      !selectionAllLoading
                    "
                  >
                    <mat-progress-spinner
                      diameter="14"
                      strokeWidth="3"
                      mode="indeterminate"
                      class="checkbox-spinner"
                    ></mat-progress-spinner>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="indicationId">
                <th mat-header-cell *matHeaderCellDef class="col col-id">
                  <span class="col-title" matTooltip="Identificador da consulta">ID Consulta</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-id">
                  {{ row.indicationId || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="appointmentDate">
                <th mat-header-cell *matHeaderCellDef class="col col-date">
                  <span class="col-title" matTooltip="Data da consulta realizada"
                    >Data da consulta</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-date">
                  {{ formatDate(row.appointmentDate, true) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="doctorName">
                <th mat-header-cell *matHeaderCellDef class="col col-doctor">
                  <span class="col-title" matTooltip="Nome do profissional">Profissional</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-doctor">
                  <span
                    class="truncate-cell"
                    [matTooltip]="getTooltipValue(row.doctorName, PROFESSIONAL_MAX_CHARS) || ''"
                    [matTooltipDisabled]="!needsTooltip(row.doctorName, PROFESSIONAL_MAX_CHARS)"
                  >
                    {{ truncateText(row.doctorName, PROFESSIONAL_MAX_CHARS) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="patientName">
                <th mat-header-cell *matHeaderCellDef class="col col-patient">
                  <span class="col-title" matTooltip="Nome do paciente">Paciente</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-patient">
                  <span
                    class="truncate-cell"
                    [matTooltip]="getTooltipValue(row.patientName, PATIENT_MAX_CHARS) || ''"
                    [matTooltipDisabled]="!needsTooltip(row.patientName, PATIENT_MAX_CHARS)"
                  >
                    {{ truncateText(row.patientName, PATIENT_MAX_CHARS) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="hasDocument">
                <th mat-header-cell *matHeaderCellDef class="col col-document">
                  <span class="col-title" matTooltip="Laudo entregue">Laudo entregue</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-document">
                  {{ formatHasDocument(row.hasDocument) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="planName">
                <th mat-header-cell *matHeaderCellDef class="col col-plan-name">
                  <span
                    class="col-title"
                    matTooltip="Plano vigente no momento to pagamento da consulta"
                    >Plano</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-plan-name">
                  {{ row.planName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="specialty">
                <th mat-header-cell *matHeaderCellDef class="col col-specialty">
                  <span class="col-title" matTooltip="Especialidade da consulta"
                    >Especialidade</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-specialty">
                  <span
                    class="truncate-cell"
                    [matTooltip]="getTooltipValue(row.specialtyName, SPECIALTY_MAX_CHARS) || ''"
                    [matTooltipDisabled]="!needsTooltip(row.specialtyName, SPECIALTY_MAX_CHARS)"
                  >
                    {{ truncateText(row.specialtyName, SPECIALTY_MAX_CHARS) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef class="col col-amount">
                  <span
                    class="col-title"
                    matTooltip="Valor da perícia médica"
                    >Valor perícia</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="numeric col col-amount">
                  {{ getTransferAmount(row) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="complementaryServices">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="col col-complementary-services"
                >
                  <span
                    class="col-title"
                    matTooltip="Serviços complementares vinculados à consulta"
                    >Serviços complementares</span
                  >
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="col col-complementary-services"
                >
                  <span
                    class="truncate-cell"
                    [matTooltip]="getComplementaryServicesTooltip(row) || ''"
                    [matTooltipDisabled]="!getComplementaryServicesTooltip(row)"
                  >
                    {{ getComplementaryServicesDisplay(row) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="serviceDoctorAmount">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="col col-service-amount"
                >
                  <span
                    class="col-title"
                    matTooltip="Soma do valor dos serviços complementares (Telemedicina)"
                    >Valor serviços</span
                  >
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="numeric col col-service-amount"
                >
                  {{ getServiceAmount(row) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="totalDoctorToPay">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  class="col col-total-to-pay"
                >
                  <span
                    class="col-title"
                    matTooltip="Soma do valor da perícia médica com os serviços complementares"
                    >Total a pagar</span
                  >
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="numeric col col-total-to-pay"
                >
                  {{ getTotalToPay(row) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="transferId">
                <th mat-header-cell *matHeaderCellDef class="col col-transfer-id">
                  <span class="col-title" matTooltip="Identificador da transferência ASAAS"
                    >ID Transferência</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-transfer-id">
                  {{ row.transferId || '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="transferStatus">
                <th mat-header-cell *matHeaderCellDef class="col col-transfer-status">
                  <span class="col-title" matTooltip="Status retornado pela API ASAAS"
                    >Status transferência</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-transfer-status">
                  {{ formatTransferStatus(row.transferStatus) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="transferReceipt">
                <th mat-header-cell *matHeaderCellDef class="col col-transfer-receipt">
                  <span class="col-title" matTooltip="Comprovante da transferência"
                    >Comprovante</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-transfer-receipt">
                  <a
                    *ngIf="row.transferReceiptUrl"
                    [href]="row.transferReceiptUrl"
                    target="_blank"
                    rel="noopener"
                  >
                    Abrir
                  </a>
                  <span *ngIf="!row.transferReceiptUrl">-</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="nfseIssued">
                <th mat-header-cell *matHeaderCellDef class="col col-nfse-issued">
                  <span class="col-title" matTooltip="NFSe emitida após a confirmação"
                    >NFSe emitida</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-nfse-issued">
                  {{ formatBoolean(row.nfseIssued) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nfseStatus">
                <th mat-header-cell *matHeaderCellDef class="col col-nfse-status">
                  <span class="col-title" matTooltip="Status retornado pela emissão da NFSe"
                    >Status NFSe</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-nfse-status">
                  {{ formatNFSeStatus(row.nfseStatus) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="nfseUrl">
                <th mat-header-cell *matHeaderCellDef class="col col-nfse-url">
                  <span class="col-title" matTooltip="Link atualizado da NFSe">Link NFSe</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-nfse-url">
                  <a *ngIf="row.nfseUrl" [href]="row.nfseUrl" target="_blank" rel="noopener">
                    Abrir NFSe
                  </a>
                  <span *ngIf="!row.nfseUrl">-</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="manualPaymentReason">
                <th mat-header-cell *matHeaderCellDef class="col col-manual-reason">
                  <span
                    class="col-title"
                    matTooltip="Motivo informado quando o pagamento foi manual"
                  >
                    Motivo pagamento manual
                  </span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-manual-reason">
                  <span
                    class="truncate-cell"
                    [matTooltip]="getManualReasonTooltip(row) || ''"
                    [matTooltipDisabled]="!getManualReasonTooltip(row)"
                  >
                    {{ getManualReasonDisplay(row) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="method">
                <th mat-header-cell *matHeaderCellDef class="col col-method">
                  <span class="col-title" matTooltip="Origem do pagamento">Método</span>
                </th>
                <td mat-cell *matCellDef="let row" class="col col-method">
                  {{ formatMethod(row.method) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="paymentDate">
                <th mat-header-cell *matHeaderCellDef class="col col-payment-date">
                  <span class="col-title" matTooltip="Data de conclusão do pagamento"
                    >Data do pagamento</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-payment-date">
                  {{ formatDate(row.paymentDate, true) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef class="col col-reason">
                  <span class="col-title" matTooltip="Motivo informado ou o status do pagamento"
                    >Motivo</span
                  >
                </th>
                <td mat-cell *matCellDef="let row" class="col col-reason">
                  <span
                    class="truncate-cell"
                    [matTooltip]="getReasonTooltip(row) || ''"
                    [matTooltipDisabled]="!getReasonTooltip(row)"
                  >
                    {{ getReasonDisplay(row) }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="col col-actions">Ações</th>
                <td mat-cell *matCellDef="let row" class="actions col col-actions">
                  <button
                    mat-mini-fab
                    color="primary"
                    matTooltip="Efetuar Pagamento"
                    aria-label="Efetuar Pagamento"
                    disableRipple
                    [disabled]="isTableBusy || actionLoadingId === getRowKey(row)"
                    (click)="openTransferModal(row)"
                  >
                    <ng-container *ngIf="actionLoadingId === getRowKey(row); else actionIcon">
                      <mat-progress-spinner
                        diameter="20"
                        strokeWidth="3"
                        mode="indeterminate"
                        class="action-spinner"
                      ></mat-progress-spinner>
                    </ng-container>
                    <ng-template #actionIcon>
                      <fa-icon icon="money-check-alt"></fa-icon>
                    </ng-template>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="actionsPayment">
                <th mat-header-cell *matHeaderCellDef class="col col-actions">Ações</th>
                <td mat-cell *matCellDef="let row" class="actions col col-method">
                  <button
                    mat-mini-fab
                    color="primary"
                    matTooltip="Emitir NFSe"
                    aria-label="Emitir NFSe"
                    disableRipple
                    *ngIf="allowEmitNFSe(row.nfseStatus)"
                    (click)="scheduleNFSe(row.transferId)"
                  >
                    <fa-icon icon="file-invoice"></fa-icon>
                  </button>

                  <button
                    mat-mini-fab
                    color="primary"
                    matTooltip="Sincronizar NFSe"
                    aria-label="allowSyncNFSe NFSe"
                    disableRipple
                    *ngIf="allowSyncNFSe(row.nfseStatus)"
                    (click)="syncNFSe(row.invoiceId)"
                  >
                    <mat-icon>autorenew</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator
            [length]="total"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onSearch($event)"
          >
          </mat-paginator>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>
